module.exports = __webpack_public_path__ + "static/media/tour-builder-icon.1a67fb70.png";